import {Typography, styled} from '@mui/material'

const StyledLinkText = styled(Typography)(() => ({
  color: 'var(--brand-primary)',
  fontSize: '0.9375rem',
  lineHeight: '113.333%',
  textDecorationLine: 'underline'
}))

export default StyledLinkText
